import React from "react";

interface IThreeStateCheckbox{
  name?:string | undefined;
  checked?: boolean | undefined;
  onChange?:( event: boolean | undefined) => void;
  id?:any;
  value?:any;
  notClick?:boolean;
  disabled?:boolean;
}

const updateInput = (ref:React.MutableRefObject<any>, checked:boolean | undefined) => {
  const input = ref.current;
  if (input) {
    input.checked = checked;
    input.indeterminate = checked == null;
  }
};

export default function ThreeStateCheckbox({
  name, checked, onChange, id, value, notClick, disabled = false
}:IThreeStateCheckbox){
  const inputRef = React.useRef(null);
  const checkedRef = React.useRef(checked);

  React.useEffect(() => {
    checkedRef.current = checked;
    updateInput(inputRef, checked);
  }, [checked]);

  const handleClick = () => {
    switch (checkedRef.current) {
      case true:
        checkedRef.current = false;
        break;
      case false:
        checkedRef.current = true;
        break;
      default: // null
        checkedRef.current = true;
        break;
    }
    updateInput(inputRef, checkedRef.current);
    if (onChange) {
      onChange(checkedRef.current);
    }
  };

  return (
    <input ref={inputRef} disabled={disabled} value={value} type="checkbox" name={name} onClick={notClick||disabled?()=>{}:handleClick} id={id}/>
  );
};